var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmation2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.17692 24.8217 0 16.0009 0C7.17826 0 0 7.17692 0 16C0 24.8231 7.17826 32 15.9991 32C24.8217 32 31.9983 24.8214 31.9983 16H32ZM1.72544 16C1.72544 8.12898 8.12855 1.72553 15.9991 1.72553C23.8697 1.72553 30.2728 8.12898 30.2728 16C30.2728 23.871 23.8697 30.2745 15.9991 30.2745C8.12855 30.2745 1.72544 23.871 1.72544 16Z",
    fill: "#1F3C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0734 7.33707C25.1091 6.73345 23.7937 6.96189 23.1381 7.85153L14.2151 19.9243L8.60674 14.7611C7.78158 14.0015 6.44403 14.0015 5.61887 14.7611C4.79371 15.5208 4.79371 16.7522 5.61887 17.5137L14.8368 26L26.6329 10.0421C27.2906 9.15429 27.0404 7.9433 26.0761 7.33968L26.0734 7.33707Z",
    fill: "#1F3C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation2);
export default __webpack_public_path__ + "static/media/confirmation2.725385a40dcbb157a977da938918bf3f.svg";
export { ForwardRef as ReactComponent };